var React = require('react');

function IcOpera (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H31.971V32H0z","transform":"translate(.028)","key":0}),React.createElement("path",{"fill":"currentColor","d":"M49.56,25.9a11.457,11.457,0,0,0-10.228-6.8A10.783,10.783,0,0,0,34.5,20.3c.242,0,.564-.08.805-.08,4.59,0,8.295,5.2,8.295,11.6s-3.7,11.6-8.295,11.6a2.757,2.757,0,0,1-.805-.08,10.056,10.056,0,0,0,4.832,1.2,11.547,11.547,0,0,0,10.228-6.8,15.11,15.11,0,0,0,0-11.84Z","transform":"translate(-18.796 -15.82)","key":1}),React.createElement("path",{"fill":"currentColor","d":"M22.731,31c0-7.68,5.476-13.92,12.241-13.92a12.619,12.619,0,0,1,7.892,3.12A15.8,15.8,0,0,0,31.106,15a16,16,0,1,0,0,32,16.345,16.345,0,0,0,11.838-5.12A12.9,12.9,0,0,1,35.053,45C28.207,44.92,22.731,38.68,22.731,31Z","transform":"translate(-15 -15)","key":2})]);
}

IcOpera.defaultProps = {"id":"ic-opera","viewBox":"0 0 32 32"};

module.exports = IcOpera;

IcOpera.default = IcOpera;
